<ion-card mode="ios" class="card-table-data">
    <ion-card-content class="ion-no-padding">
        <ion-grid class="team">
            <ion-row class="header" *ngIf="processConfig && varIsAvailable">
                <ion-col class="ion-text-center" size="2">
                    {{ "freeEvaluationEndYear.finalConcept" | translate }}
                </ion-col>
                <ion-col class="ion-text-center" size="3">
                    <ion-label>
                        {{ "freeEvaluationEndYear.excellentFinalConcpets" | translate }}
                    </ion-label>
                </ion-col>
                <ion-col class="ion-text-center" size="3">
                    <ion-label>
                        {{ "freeEvaluationEndYear.aboveFinalConcpets" | translate }}
                    </ion-label>
                </ion-col>
                <ion-col class="ion-text-center" size="3">
                    <ion-label>
                        {{ "freeEvaluationEndYear.otherFinalConcpets" | translate }}
                    </ion-label>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="evaluations && processConfig && varIsAvailable">
                <ion-col class="ion-text-center ion-margin-vertical ion-align-self-center" size="2">
                </ion-col>
                <ion-col class="ion-text-center ion-margin-vertical" size="3">
                    <ion-label color="{{ lastLimitColor }}">
                        {{ endYearEvalRule.lastSelecteds }} {{ "generic.of" | translate }}
                        {{
                            dynamicLimitConcepts ?
                                (
                                    endYearEvalRule.penultimateSelecteds >
                                    endYearEvalRule.maxLast
                                        ? endYearEvalRule.maxPenultimate - endYearEvalRule.penultimateSelecteds
                                        : endYearEvalRule.maxLast
                                )
                                : endYearEvalRule.maxLast
                        }}
                    </ion-label>
                </ion-col>
                <ion-col class="ion-text-center ion-margin-vertical" size="3">
                    <ion-label color="{{ penultimateLimitColor }}">
                        {{ endYearEvalRule.penultimateSelecteds }}
                        {{ "generic.of" | translate }}
                        {{
                            endYearEvalRule.lastSelecteds <= endYearEvalRule.maxLast
                                ? endYearEvalRule.maxPenultimate - endYearEvalRule.lastSelecteds
                                : endYearEvalRule.maxPenultimate - endYearEvalRule.maxLast
                        }}
                    </ion-label>
                </ion-col>
                <ion-col class="ion-text-center ion-margin-vertical" size="3">
                    <ion-label color="{{ remainingLimitColor }}">
                        {{ endYearEvalRule.remainingSelecteds }}
                        {{ "generic.of" | translate }}
                        {{ endYearEvalRule.maxRemaining }}
                    </ion-label>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="processConfig && !varIsAvailable"
                     style="text-align: center; align-content: center; font-size: 16px">
                <ion-col size-xs="12" size-sm="12" size-md="12">
                    <ion-label *ngIf="processWillOpen" class="ion-text-wrap" color="danger">
                        {{ "freeEvaluationEndYear.evaluationWillOpen" | translate }}
                        {{ processConfig?.startDate }}
                    </ion-label>
                    <ion-label *ngIf="processIsClosed" class="ion-text-wrap" color="danger">
                        {{ "freeEvaluationEndYear.evaluationIsClosed" | translate }}
                        {{ processConfig?.endDate }}.
                        <br/>
                        {{ "freeEvaluationEndYear.evaluationIsClosedCannotSend" | translate }}
                    </ion-label>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>
